import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {
  AppConfigService, FeatureFlags, FeatureFlagService,
  // DEFAULT_FEATURE_FLAGS_ENDPOINT
} from '@eucoms/common-components';

import { constants } from '@app/constants';
export const DEFAULT_FEATURE_FLAGS_ENDPOINT = '/api/Services/MyAccountService.svc/GetFeatureFlags';

@Injectable({
  providedIn: 'root'
})
export class MockBaseUrlFeatureFlagService extends FeatureFlagService {
  private FEATURE_FLAGS_ENDPOINT = constants.CoreServicesInitOptions.additionalConfig['common'].baseUrl + DEFAULT_FEATURE_FLAGS_ENDPOINT;

  constructor(private httpClient: HttpClient, appConfig: AppConfigService) {
    super(appConfig);
  }

  static forRoot() {
    return {
      provide: FeatureFlagService,
      useClass: MockBaseUrlFeatureFlagService
    };
  }

  protected readFeatureFlags(): Observable<FeatureFlags> {
    return this.httpClient
      .get<FeatureFlags>(this.FEATURE_FLAGS_ENDPOINT)
      .pipe(catchError(() => of({} as FeatureFlags)));
  }
}
